import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@material-ui/core';
import cx from 'classnames';
import moment from 'moment-timezone';
import React, { useCallback, useEffect, useState } from 'react';
import { getDisplayNameChangeHistories } from '../../../services/api/Moderation';
import { DisplayNameReviewStatus, IDisplayName } from '../../../services/types';
import useStyles from './DisplayNameChangeHistory.styles';

interface IProps {
  displayName?: IDisplayName;
  onClose: () => void;
}

const RowsPerPage = 10;

const DisplayNameChangeHistory = (props: IProps): JSX.Element => {
  const classes = useStyles();
  const { displayName, onClose } = props;
  const displayNameId = displayName?.id;
  const userId = displayName?.userId;

  const [changeHistories, setChangeHistories] = useState<IDisplayName[]>([]);
  const [page, setPage] = useState<number>(0);
  const [totalCount, setTotalCount] = useState<number>(0);

  const handlePageChange = useCallback((e: unknown, page: number) => {
    setPage(page);
  }, []);

  const fetchChangeHistories = useCallback(async () => {
    if (!userId) {
      return;
    }

    const { data } = await getDisplayNameChangeHistories(userId, page + 1, RowsPerPage);

    setChangeHistories(data.items);
    setTotalCount(data?.totalCount || 0);
  }, [userId, page]);

  useEffect(() => {
    fetchChangeHistories();
  }, [fetchChangeHistories]);

  return (
    <Paper className={classes.wrap}>
      <Typography variant="h6">Display name change history</Typography>
      <Typography className={classes.subtitle}>{`Display Name Id: ${displayNameId}`}</Typography>
      <TablePagination
        count={totalCount}
        page={page}
        rowsPerPage={RowsPerPage}
        rowsPerPageOptions={[]}
        onChangePage={handlePageChange}
        backIconButtonProps={{
          className: classes.paginationIconButton,
        }}
        nextIconButtonProps={{
          className: classes.paginationIconButton,
        }}
        classes={{
          toolbar: classes.paginationToolbar,
        }}
      />
      <TableContainer component={'div'} className={classes.tableWrap}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Display name</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Changed at</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {changeHistories.map(h => (
              <TableRow key={h.id} hover className={classes.contentRow}>
                <TableCell>{h.id}</TableCell>
                <TableCell style={{ width: 300 }}>{h.displayName}</TableCell>
                <TableCell
                  className={cx({
                    [classes.reviewStatus]: true,
                    [classes.approve]: h.review.status === DisplayNameReviewStatus.Approved,
                    [classes.fatal]: h.review.status === DisplayNameReviewStatus.Blocked,
                  })}
                >
                  {h.review.status.replace('_', ' ')}
                </TableCell>
                <TableCell className={classes.contentDesc2}>{moment(h.createdAt).format('ll HH:mm:ss')}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box className={classes.buttonWrap}>
        <Button
          variant="contained"
          color="primary"
          onClick={onClose}
          style={{
            textTransform: 'uppercase',
          }}
        >
          Close
        </Button>
      </Box>
    </Paper>
  );
};

export default DisplayNameChangeHistory;
